import { TranslateService } from '@ngx-translate/core';
import { arrowRenderToExpand, changeExpiryRender, genericStringFormatter, storageConverterRender, genericDateFormatterWithToolTip, statusRender } from '../../dataprotection-common/common-renderers';

export function getDatatableConfig(translate:TranslateService) {
    return {
        dom: 'Bfrtip',
        columns: [
            { "data": null, "width": "1px", "title": '&nbsp;'},
            { "data": null, "width": "1px", "title": '&nbsp;'},
            { "data": "creationDate", "width": "21%", "title": translate.instant('dpsModule.restorePoints.grid.header.creationDate')},
            { "data": "expiryDate", "width": "21%", "title": translate.instant('dpsModule.restorePoints.grid.header.expiryDate')},
            { "data": "entityName", "width": "18%", "title": translate.instant('dpsModule.restorePoints.grid.header.name')},
            { "data": "children", "width": "8%", "title": translate.instant('dpsModule.restorePoints.grid.header.virtualMachines')},
            { "data": "status", "width": "10%", "title": translate.instant('dpsModule.restorePoints.grid.header.status')},
            { "data": "size", "width": "10%", "title": translate.instant('dpsModule.restorePoints.grid.header.size')},
            { "data": "storageConsumed", "width": "10%", "title": translate.instant('dpsModule.restorePoints.grid.header.storageConsumed')},
            { "data": "creationDate", "width": "0%", "title": ""},
            { "data": "expiryDate", "width": "0%", "title": ""}
        ],
        columnDefs: [
            {
                "targets": [ 0 ],
                "orderable": false,
                "mRender": function ( data, type, row ) {
                    return arrowRenderToExpand(data, type, row, "children");
                }
            },
            {
                "targets": [ 1 ],
                "orderable": false,
                "mRender": function ( data, type, row ) {
                    return changeExpiryRender(data, type, row);
                }
            },
            {
                "targets": [ 2 ],
                "orderData":[ 9 ],
                "mRender": function ( data, type, row ) {
                    if ( row && row.creationDate ) {
                        return genericDateFormatterWithToolTip(row.creationDate);
                    }else{
                        return "-";
                    }
                }
            },
            {
                "targets": [ 3 ],
                "orderData":[ 10 ],
                "mRender": function ( data, type, row ) {
                    if ( row && row.expiryDate ) {
                        return genericDateFormatterWithToolTip(row.expiryDate);
                    }else{
                        return "-";
                    }
                }
            },
            {
                "targets": [ 4 ],
                "mRender": function ( data, type, row ) {
                    if ( type === 'display' ) {
                        if ( row && row.entityName ) {
                            return genericStringFormatter(data);
                        }else{
                            return "-";
                        }
                    }
                    return ((row && row.entityName) ? data : "-");
                }
            },
            {
                "targets": [ 5 ],
                "mRender": function ( data, type, row ) {
                    if(row && row.children) {
                        return row.children.length;
                    }else{
                        return "0";
                    }
                }
            },
            {
                "targets": [ 6 ],
                "mRender": function ( data, type, row ) {
                    if(row && row.status) {
                        return statusRender(data, type, row, translate);
                    }else{
                        return "-";
                    }
                }
            },
            {
                "targets": [ 7 ],
                "mRender": function ( data, type, row ) {
                    if ( type === 'display' ) {
                        if(row && row.size && row.size > 0) {
                            return storageConverterRender(row.size, 'MB');
                        }else {
                            return "0 MB";
                        }
                    }
                    return ((row && row.size && row.size > 0) ? row.size : 0);
                }
            },
            {
                "targets": [ 8 ],
                "mRender": function ( data, type, row ) {
                    if ( type === 'display' ) {
                        if(row && row.storageConsumed && row.storageConsumed > 0) {
                            return storageConverterRender(row.storageConsumed, 'MB');
                        }else {
                            return "0 MB";
                        }
                    }
                    return ((row && row.storageConsumed && row.storageConsumed > 0) ? row.storageConsumed : 0);
                }
            },
            {
                "targets": [ 9 ],
                "visible": false,
                "type": "date-sort-custom",
                "searchable": false,
                "mRender": function ( data, type, row ) {
                    if ( row && row.creationDate ) {
                        return data;
                    }else{
                        return "-";
                    }
                }
            },
            {
                "targets": [ 10 ],
                "visible": false,
                "type": "date-sort-custom",
                "searchable": false,
                "mRender": function ( data, type, row ) {
                    if ( row && row.expiryDate ) {
                        return data;
                    }else{
                        return "-";
                    }
                }
            }
        ],
        "autoWidth": false,
        "oLanguage": {
            "sSearch": "",
            "sEmptyTable": translate.instant('dpsModule.restorePoints.grid.message.emptyTable'),
            "sInfoEmpty": translate.instant('dpsModule.restorePoints.grid.message.infoEmpty')
        },
        "scrollY":        "50vh",
        "scrollCollapse": true,
        "paging":         false,
        "bFilter": true,
        'bDestroy': true,
        "bUseRendered": false,
        "order": [[ 0, "desc" ]],
        "rowCallback": function( row, data ) {
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/restore-points/restore-points.dt.config.ts